// extracted by mini-css-extract-plugin
export default {"MainContent_wrapper":"MainContent_MainContent_wrapper__blhph"};